const a = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" aria-hidden="true"><path d="M17 3.25A4.75 4.75 0 0 1 21.75 8v12.75H7A4.75 4.75 0 0 1 2.25 16V8A4.75 4.75 0 0 1 7 3.25zM7 4.75A3.25 3.25 0 0 0 3.75 8v8c0 1.8 1.46 3.25 3.25 3.25h13.25V8c0-1.8-1.46-3.25-3.25-3.25zm.89 6.22a1.03 1.03 0 1 1 0 2.06 1.03 1.03 0 0 1 0-2.06m4.11 0a1.03 1.03 0 1 1 0 2.06 1.03 1.03 0 0 1 0-2.06m4.11 0a1.03 1.03 0 1 1 0 2.06 1.03 1.03 0 0 1 0-2.06"/></svg>';
export {
  a as w
};
